var map = {
	"./404.svg": "a14a",
	"./Import.svg": "2c7b",
	"./addTask.svg": "9968",
	"./batchAdopt.svg": "32ac",
	"./batchCancel.svg": "e34b",
	"./batchCheck.svg": "4c57",
	"./batchSettlement.svg": "3ba4",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./download.svg": "4dae",
	"./drag.svg": "9bbf",
	"./dzzx.svg": "c5ab",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./export.svg": "077e",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./ffmx.svg": "278e",
	"./form.svg": "eb1b",
	"./form1.svg": "77f7",
	"./fullscreen.svg": "9921d",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./invoiceIcon.svg": "2b85",
	"./kaipiao.svg": "67d0",
	"./kp.svg": "93e5",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./money1.svg": "e3d4",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pd.svg": "a75a",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./people1.svg": "ee7e",
	"./peoples.svg": "2f11",
	"./pldk.svg": "a2a8",
	"./qiye.svg": "a294",
	"./qq.svg": "1430",
	"./qrCode.svg": "ad26",
	"./qylg.svg": "7eb3",
	"./qyxx.svg": "b0af",
	"./search.svg": "8e8d",
	"./search1.svg": "082e",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./statistics.svg": "a1cf",
	"./sy.svg": "3ca4",
	"./system.svg": "30a9",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./upload.svg": "9d82",
	"./user.svg": "b3b5",
	"./verifcationCode.svg": "b784",
	"./warning.svg": "7e6f",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6",
	"./zjzh.svg": "e4dc",
	"./刷新 (Stroke).svg": "7f1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";